const fields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'standardEfficiency',
    label: 'report.fields.stdEfficiency',
    header: 'standardEfficiency',
    filter: false,
    width: 30,
  },
  {
    key: 'fuelConsumption',
    label: 'report.fields.literConsumption',
    header: 'fuelConsumption',
    filter: false,
    width: 30,
  },
  {
    key: 'totalMileage',
    label: 'report.fields.totalDistance',
    header: 'totalMileage',
    filter: false,
    width: 30,
  },
  {
    key: 'actualEfficiency',
    label: 'report.fields.actualEfficiency',
    header: 'actualEfficiency',
    filter: false,
    width: 30,
  },
  {
    key: 'consistency',
    label: 'report.fields.consistency',
    header: 'consistency',
    filter: false,
    width: 30,
  },
]

export default fields
